/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentReportQueryFramework extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentReportQueryFramework");
    }

    getFixupPrototypeFunction() { return AssessmentReportQueryFramework.fixupPrototype; }

    static newInstance(model: Partial<AssessmentReportQueryFramework>): AssessmentReportQueryFramework {
        let obj = Object.assign(new AssessmentReportQueryFramework(), model);
        AssessmentReportQueryFramework.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentReportQueryFramework>): AssessmentReportQueryFramework {
        if (!model) return null;
        return AssessmentReportQueryFramework.newInstance(<AssessmentReportQueryFramework> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentReportQueryFramework) {
        if (!obj) return;

        models.AssessmentReportQueryFramework.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentReportQueryFramework): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentReportQueryFramework.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of framework
     */
    framework_ids: Array<string>;

}
